// extracted by mini-css-extract-plugin
module.exports = {"container":"_f1222b59","categoryContainer":"_28f578e9"};